import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "cowing-modal",
  templateUrl: "./cowing-modal.component.html",
  styleUrls: ["./cowing-modal.component.scss"],
})
export class CowingModalComponent {
  @Input('isOpen') isOpen = false;
  @Output('toggle') toggle: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private _translate: TranslateService
  ) {}

  clickedOutside(e) {
    if (e.target.className === 'modal-wrapper') {
      this.toggle.emit(false);
      this.isOpen = false;
    }
  }

  toggleModal(e) {
    this.isOpen = e;
    this.toggle.emit(e);
  }
}
